// Helpers to turn user-pasted URLs into embeddable player/chat URLs.

export function youtubeId(input) {
  if (!input) return "";
  const s = input.trim();
  if (/^[a-zA-Z0-9_-]{11}$/.test(s)) return s;
  const patterns = [
    /[?&]v=([a-zA-Z0-9_-]{11})/,
    /youtu\.be\/([a-zA-Z0-9_-]{11})/,
    /youtube\.com\/live\/([a-zA-Z0-9_-]{11})/,
    /youtube\.com\/embed\/([a-zA-Z0-9_-]{11})/,
    /youtube\.com\/shorts\/([a-zA-Z0-9_-]{11})/,
  ];
  for (const p of patterns) {
    const m = s.match(p);
    if (m) return m[1];
  }
  return "";
}

export function youtubeEmbed(input, { autoplay = true } = {}) {
  const id = youtubeId(input);
  if (!id) return "";
  return `https://www.youtube.com/embed/${id}?autoplay=${autoplay ? 1 : 0}&rel=0&modestbranding=1`;
}

export function youtubeChat(input) {
  const id = youtubeId(input);
  if (!id) return "";
  const host = typeof window !== "undefined" ? window.location.hostname : "localhost";
  return `https://www.youtube.com/live_chat?v=${id}&embed_domain=${host}`;
}

export function facebookEmbed(input, { autoplay = true } = {}) {
  if (!input) return "";
  const href = encodeURIComponent(input.trim());
  return `https://www.facebook.com/plugins/video.php?href=${href}&show_text=false&autoplay=${autoplay}&width=560`;
}

export function buildPlayer(platform, url, autoplay = true) {
  if (platform === "facebook") return facebookEmbed(url, { autoplay });
  return youtubeEmbed(url, { autoplay });
}
